import { getLocaleNumberSymbol, NumberSymbol } from '@angular/common';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SE_UI_DATE_FORMATS } from '../se-pickers/se-ui-date-formats';

import { CommonApplicationSettingsService } from './settings/common-application-settings.service';

@Injectable({
    providedIn: 'root',
})
export class CultureService {
    private settings;

    constructor(private commonApplicationSettingsService: CommonApplicationSettingsService) {}

    // public functions

    async initializeAsync() {
        const commonSettings = await firstValueFrom(this.commonApplicationSettingsService.getSettings());

        this.settings = commonSettings.serializableCulture;

        // inizializzo il format provider con i valori del culture service
        SE_UI_DATE_FORMATS.parse.dateInput = this.settings.shortDatePattern.toUpperCase();

        SE_UI_DATE_FORMATS.display.dateA11yLabel = this.settings.shortDatePattern.toUpperCase();
        SE_UI_DATE_FORMATS.display.dateInput = this.settings.shortDatePattern.toUpperCase();
        SE_UI_DATE_FORMATS.display.monthYearA11yLabel = this.settings.shortDatePattern.toUpperCase();
        SE_UI_DATE_FORMATS.display.monthYearLabel = this.settings.shortDatePattern.toUpperCase();
    }

    async getCultureAsync() {
        const commonSettings = await firstValueFrom(this.commonApplicationSettingsService.getSettings());

        return commonSettings.serializableCulture.cultureName;
    }

    getCulture() {
        return this.settings.cultureName;
    }

    getDecimalSeparator() {
        return getLocaleNumberSymbol(this.getCulture(), NumberSymbol.Decimal);
    }

    getMoneySeparator() {
        return getLocaleNumberSymbol(this.getCulture(), NumberSymbol.CurrencyDecimal);
    }

    getShortDateTimePattern() {
        return this.settings.shortDatePattern + ' ' + this.settings.shortTimePattern;
    }

    getShortDatePattern() {
        return this.settings.shortDatePattern;
    }

    getShortTimePattern() {
        return this.settings.shortTimePattern;
    }

    getTimeSeparator() {
        return this.settings.timeSeparator;
    }

    getDateSeparator() {
        return this.settings.dateSeparator;
    }
}
